import { render, staticRenderFns } from "./ResearchAssistant.vue?vue&type=template&id=40fd1348&scoped=true&"
import script from "./ResearchAssistant.vue?vue&type=script&lang=js&"
export * from "./ResearchAssistant.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=40fd1348&prod&scoped=true&lang=css&"
import style1 from "./ResearchAssistant.vue?vue&type=style&index=1&id=40fd1348&prod&scoped=true&lang=css&"
import style2 from "./ResearchAssistant.vue?vue&type=style&index=2&id=40fd1348&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fd1348",
  null
  
)

export default component.exports